import { atom } from 'recoil'

export const projects = atom({
  key: 'projects',
  default: [],
})

export default projects
